<template>
  <div class="index">
    <OrgSettlement ref="orgSettlementRef"></OrgSettlement>
  </div>
</template>

<script>
import { mapMutations, } from 'vuex';
import OrgSettlement from './OrgSettlement.vue'
export default {
  name: 'financeCenterEduSettlementIndex',
  components: {
    OrgSettlement
  },
  activated() {
    this.$refs.orgSettlementRef.cacheSearch()
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('financeCenterEduSettlementIndex')
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
  }
}
</script>

